import * as Sentry from '@sentry/browser';
import urlParse from 'url-parse';

import { fetchWithTimeout } from './fetch-with-timeout';

const supportsNetworkInterfaceStatus = 'onLine' in window.navigator;

export async function isReachable(url: string, timeout = 5000): Promise<boolean> {
  /**
   * Online/offline status API is not fully reliable.
   * It only checks status of network interface, not connection to the internet.
   * But if navigator.onLine returns false we are sure that there is no internet.
   */
  if (supportsNetworkInterfaceStatus && !window.navigator.onLine) {
    // eslint-disable-next-line no-console
    console.warn('Browser is offline');

    Sentry.addBreadcrumb({
      category: 'connectivity',
      message: 'Browser is offline',
      level: 'warning',
    });
    return false;
  }

  try {
    const parseQuery = true;
    const parsedUrl = urlParse(url, parseQuery);
    const uniqueUrl = parsedUrl.set('query', {
      ...parsedUrl.query,
      v: Date.now(),
    });

    await (await fetchWithTimeout(uniqueUrl.toString(), { method: 'HEAD' }, timeout)).text();

    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Cannot reach auth server');

    Sentry.addBreadcrumb({
      category: 'connectivity',
      message: 'Cannot reach auth server',
      level: 'warning',
      data: { error },
    });
  }

  return false;
}
